export default [
  {
    path: '/signin',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/modules/login/_views/Login'),
    meta: {
      layout: 'blank',
      isPublic: true
    }
  }, {
    path: '/resetpassword/:token',
    name: 'resetpassword',
    component: () =>
      import(
        /* webpackChunkName: "login" */ '@/modules/login/_views/ResetPassword'
      ),
    meta: {
      layout: 'blank',
      isPublic: true
    }
  },
  {
    path: '/resetpasscode/:token',
    name: 'resetpasscode',
    component: () =>
      import(
        /* webpackChunkName: 'reset-passcode' */ '@/modules/login/_views/ResetPasscode'
      ),
    meta: {
      layout: 'blank',
      isPublic: true
    }
  }
]
